export const banIpAddressData = [
  {
    id: '1',
    ip: '211.11.0.25',
    reason: 'You can get on-demand services in order to find a nearby service.',
    date: '12 Jul 2023',
  },
  {
    id: '2',
    ip: '211.03.0.11',
    reason: 'Extract pricing information at inventory levels.',
    date: '24 Aug 2023',
  },
  {
    id: '3',
    ip: '211.24.0.17',
    reason: 'Fetching data for competitors to gain competitive advantage.',
    date: '07 Sep 2023',
  },
  {
    id: '4',
    ip: '211.12.0.34',
    reason: 'Temporarily block to protect user accounts from internet fraudsters.',
    date: '13 Oct 2023',
  },
];
